import { CommonModule } from '@angular/common';
import { Component, Input, Output, EventEmitter } from '@angular/core';

/**
 * Componente para mostrar tipos de productos seleccionables
 * @since 1.0.0
 */
@Component({
    selector: 'app-tipos-producto',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './tipos-productos.component.html',
    styleUrls: ['./tipos-productos.component.css'],
})
export class TiposProductoComponent {
    /** Lista de tipos de productos disponibles */
    @Input() tipos: any[] = [];

    /** Tipos de productos actualmente seleccionados */
    @Input() tiposSeleccionados: any[] = [];

    /** Función para obtener color por tipo de producto */
    @Input() getTipoColor!: (tipoId: number) => string;

    /** Evento emitido cuando se selecciona/deselecciona un tipo */
    @Output() tipoSeleccionado = new EventEmitter<any>();
}
